import { get } from 'lodash';

export const getState = (state, param = null, defaultValue = null) => get(state, `deliveryNote.return.detail${(param ? `.${param}` : '')}`, defaultValue);
